import { render, staticRenderFns } from "./beniBox.vue?vue&type=template&id=77b9a716&scoped=true"
import script from "./beniBox.vue?vue&type=script&lang=js"
export * from "./beniBox.vue?vue&type=script&lang=js"
import style0 from "./beniBox.vue?vue&type=style&index=0&id=77b9a716&prod&scoped=true&lang=css"
import style1 from "./beniBox.vue?vue&type=style&index=1&id=77b9a716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9a716",
  null
  
)

export default component.exports